module.exports = __webpack_public_path__ + "img/download_apple.2ce833e7.png";